import { render, staticRenderFns } from "./gain_order_type.vue?vue&type=template&id=9d81c4fe&scoped=true"
import script from "./gain_order_type.vue?vue&type=script&lang=js"
export * from "./gain_order_type.vue?vue&type=script&lang=js"
import style0 from "./gain_order_type.vue?vue&type=style&index=0&id=9d81c4fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d81c4fe",
  null
  
)

export default component.exports